<template>
    <div class="system-roles list-page page">
        <div class="page--list">
            <div class="scroll-wrapper pd4 set--bottom-foot-padding">
                <list-tool-bar>
                    <el-button type="primary"  style="margin-bottom:15px;" v-if="auth.eidtEmp" @click.stop="handleEditEmpDia">批量修改对接员工</el-button>
                </list-tool-bar>
                <el-row  style="flex-wrap: wrap;padding:16px 16px 0 16px;background:#F4F7FA; margin-bottom:15px;" class="flex">
                    <el-col :span="6" style="margin-bottom:16px;">
                        <div>
                            <el-input placeholder="请输入内容" v-model.trim="search_value" class="input-with-select">
                                <el-select style="width:120px;" v-model="search_type" slot="prepend" placeholder="请选择">
                                    <el-option v-for="item in searchTypeEnum" :key="item.value" :label="item.name" :value="item.value"></el-option>
                                </el-select>
                            </el-input>
                        </div>
                    </el-col>
                    <el-col :span="6" style="margin-left:24px;margin-bottom:16px;">
                        <div style="display:flex;align-items: center;">
                            <div style="flex-shrink: 0;">对接员工：</div>
                            <el-input placeholder="请输入" v-model.trim="search_name" class="input-with-select"></el-input>
                        </div>
                    </el-col>
                    <el-button style="margin-left:24px;margin-bottom:16px;" type="primary" @click.stop="handleSubmit">搜索</el-button>
                    <el-button @click.stop="handleClear">清空</el-button>
                </el-row>
                <el-table :data="tableData" @selection-change="handleSelectionChange">
                     <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column label="渠道编号" prop="channelCode"></el-table-column>
                    <el-table-column label="渠道名称" prop="channelName" min-width="160"></el-table-column>
                    <el-table-column label="联系人" prop="conName"></el-table-column>
                    <el-table-column label="电话号码"  prop="channelPhone">
                    </el-table-column>
                    <el-table-column label="对接员工"  prop="connEmpName">
                    </el-table-column>
                    <el-table-column label="类型"  prop="type">
                         <template slot-scope="scope">
                            <!-- <div>{{scope.row.type==1?'个人':scope.row.type==2?'公司':scope.row.type==3?'集团资源':''}}</div> -->
                            <div>{{scope.row.type}}</div>
                        </template>
                    </el-table-column>
                    <!--  -->
                    <el-table-column label="证件号（身份证或公司编号）"  prop="idcard" min-width="240">
                    </el-table-column>
                    <!-- <el-table-column label="存在系统"  prop="sysName">
                    </el-table-column> -->
                    <el-table-column label="创建时间"  prop="createTime"   min-width="120">
                        <template slot-scope="scope">
                            <div v-html="scope.row.createTime"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作"
                        fixed="right" min-width="120">
                        <template slot-scope="scope">
                            <div class="operator-cell">
                                <el-button
                                    v-if="true||auth.save"
                                    type="text"
                                    @click.stop="handleDetail(scope.row)"
                                >详情</el-button>
                             
                                <el-button
                                    v-if="true||auth.delete"
                                    type="text"
                                    @click.stop="handleDelete(scope.row)"
                                >删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <list-foot-bar>
                <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page.sync="pageNum" :page-size="pageSize" :total="total" @size-change="handlePageSizeChange" @current-change="handlePageNoChange"></el-pagination>
            </list-foot-bar>
        </div>

        <!-- 批量修改对接员工 -->
        <el-dialog class="editEmpDia"
        :visible="showEditEmpDia"
        @close="cancelEditEmpDiaTop"
        title="修改渠道商对接员工"
        width="560px">
         <el-form 
                :model="editEmpInfo"
                :rules="editEmpInforules"
                label-width="140px"
                label-suffix=":"
                ref="editEmpInfo"
                style="width:100%;"
                @submit.prevent="seveEditEmpDia"
                >
                <el-form-item label="员工存在系统" prop="sys">
                    <el-radio-group v-model="editEmpInfo.sys">
                        <el-radio label="CRM">房产CRM</el-radio>
                        <el-radio label="AYM">移民CRM</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="对接员工" prop="empid">
                    <template>
                        <el-select class='empidselect' v-model="editEmpInfo.empid" filterable remote reserve-keyword placeholder="请输入" :remote-method="remoteMethod" :loading="loading">
                            <el-option v-for="item in empOptions" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
                
     

            <!-- <el-form-item label="绩效工资核算月份" prop="grantTime1" style="margin-bottom:24px;">
                    <el-date-picker  :type="datetype"  style="width:380px;" v-model.trim="allGrant.grantTime1" :value-format="valueformat" placeholder="请选择"></el-date-picker>
            </el-form-item>
            <el-form-item label="绩效工资发放月份" prop="grantTime2" style="margin-bottom:24px;">
                    <el-date-picker  :type="datetype"  style="width:380px;" v-model.trim="allGrant.grantTime2" :value-format="valueformat" placeholder="请选择"></el-date-picker>
            </el-form-item> -->
         </el-form>
            <div slot="footer">
                <el-button @click="cancelEditEmpDia" >取消</el-button>
                <el-button @click="seveEditEmpDia"  type="primary">保存</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            tableData: [],
            search_value: "",
            search_name:'',
            search_type: 1,
            pageNum: 1,
            pageSize: 10,
            total: 0,

            searchTypeEnum: [
                { name: "渠道编号", value: 1 },
                { name: "渠道名称", value: 2 },
                { name: "电话号码", value: 3 },
            ],
            auth:{
               delete:false,
               eidtEmp:false, 
            },
            showEditEmpDia:false,
            editEmpInfo:{
                sys:'',
                empid:'',
            },
            editEmpInforules:{
                sys      : { required: true, message: "请选择员工存在系统",trigger:['change', 'blur'] },
                //  empid      : { required: true, message: "请选择对接员工",trigger:['change', 'blur'] }
            },
            empOptions:[],
            multipleSelection: "",
            loading: false,
        };
    },
    created() {
        this.auth.delete = this.$hasAuthFor("api/channel/deleteChannel"); //删除
        this.auth.eidtEmp = this.$hasAuthFor("api/common/channel/updateChannelConnEmp"); //批量修改对接员工

        
        this.fetchData();
    },
    mounted() {},
    watch: {},
    computed: {},
    methods: {
        // 搜索对接员工
        async remoteMethod(query) {
            console.log(query);
            if (query !== "") {
                this.loading = true;
                const res = await this.$axios({
                    url: "/api/employee/queryEmployeeList",
                    method: "post",
                    data: {
                        searchName: query,
                    },
                });
                if (res.code === 2000) {
                    this.loading = false;
                    res.data.empList.map((item) => {
                        item.label = item.name + "--" +item.usercode+"--" + item.phone;
                        item.value = item.usercode;
                    });
                    this.empOptions = res.data.empList;
                }
            } else {
                this.empOptions = [];
            }
        },
        cancelEditEmpDiaTop(){
            if(this.showEditEmpDia){
                this.cancelEditEmpDia()
            }
        },
        cancelEditEmpDia(){
            this.editEmpInfo.sys = ''
             this.editEmpInfo.empid = ''
            this.showEditEmpDia = false
            setTimeout(() => {
                this.$refs.editEmpInfo.clearValidate();
            }, 20);
        },

        handleEditEmpDia(){
             if (this.multipleSelection.length == 0) {
                this.$message({
                    message: "请选择需要修改的数据",
                    type: "warning",
                });
                return;
            }

            this.showEditEmpDia = true
        },
         handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        async seveEditEmpDia() {
            let loadingRef;
            try {
                await this.$refs.editEmpInfo.validate();
                loadingRef = this.$loading({
                    target: ".editEmpDia .el-dialog"
                });

                let codearr = [];
                this.multipleSelection.forEach((item) => {
                    codearr.push(item.channelCode);
                });
                const res = await this.$axios({
                    url: "/api/common/channel/updateChannelConnEmp",
                    method: "post",
                    data: {
                        channelCodes: codearr.join(),
                        empCode: this.editEmpInfo.empid,
                        sysCode: this.editEmpInfo.sys,
                    }
                })
                if (res.code === 2000) {
                    this.$message({
                        message: "保存成功",
                        type: "success"
                    });
                    loadingRef && loadingRef.close();
                    this.cancelEditEmpDia()
                    this.fetchData();

                } else if (res.code !== 1003)
                    throw res;
            } catch (reason) {
                reason && this.$message({
                    message: reason.msg || "保存失败",
                    type: "error"
                });
                loadingRef && loadingRef.close();
                console.warn(reason);
            }

        },

        // 详情
        handleDetail(data){
            // 渠道详情

            this.$router.push({
				path: `/customer/channelPhoneList/Detail`,
				query: {id: data.id,channelCode:data.channelCode}
			});

            // 渠道新增 编辑

            // this.$router.push({
			// 	path: `/customer/channelPhoneList/add`,
			// 	query: {id: data.id}
			// });

            // 在线签署渠道协议列表
            // this.$router.push({
			// 	path: `/customer/channelLineList`,
			// 	query: {id: data.id}
			// });

        },
        // 点击表格行操作按钮: 删除
        async handleDelete(data) {
            let loadingRef;
            try {
                await this.$confirm("请先确定该渠道在各业务系统中是否关联客户，删除后会同步删除业务系统中的渠道，您确定要删除么？", "删除渠道提示信息")
                loadingRef = this.$loading();
                const res = await this.$axios({
                    url: "/api/channel/deleteChannel",
                    method: "post",
                    data: {
                        id: parseInt(data.id)
                    }
                })
                if (res.code === 2000) {
                    this.$message({
                        message: "删除成功",
                        type: "success"
                    });
                    loadingRef && loadingRef.close();
                    this.fetchData();

                } else if (res.code !== 1003)
                    throw res;

            } catch (reason) {
                if (reason !== "cancel") {
                    this.$message({
                        message: reason.msg || "删除失败",
                        type: "warning"
                    });
                }
                loadingRef && loadingRef.close();
            }
        },
        handleSubmit() {
            this.pageNum=1
            this.pageSize=10
            this.fetchData();
        },
        handleClear() {
            this.pageNum=1
            this.pageSize=10
            this.search_value = "";
            this.search_name = "";
            this.search_type = 1;
            this.fetchData();
        },
        async fetchData() {
            const loading = this.$loading();
            const res = await this.$axios({
                url: "/api/channel/queryChannelPhoneList",
                method: "post",
                data: {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    search_type: this.search_type,
                    search_value: this.search_value,
                    search_name: this.search_name,
                },
            });
            loading.close();
            if (res.code === 2000) {
                this.tableData = res.data.channelList || [];
                this.total = res.data.count || 0;
            }else{
                this.$message({
                    message: res.msg || "获取数据失败",
                    type: "warning"
                });
            }
        },
        // 翻页相关
        handlePageSizeChange(size) {
            this.pageSize = size;
            this.fetchData();
        },
        // 翻页相关
        handlePageNoChange(no) {
            this.pageNum = no;
            this.fetchData();
        },
    },
};
</script>
<style lang="scss" scoped>
    .empidselect{
        width: 340px;
    }
</style>